const LoadingElement = ({ element }) => {
	return <div className={`loading loading--${element}`}></div>;
};

export default LoadingElement;
